module.exports = __webpack_public_path__ + "img/1F1F0-1F1F7.a20c33ae.svg";